import React, { useState } from 'react';
import '../styles/domainCompliance.scss';

const complianceData = [
    {
        title: 'Governance',
        icon: '🏛️',
        percent: 90,
        status: 'Compliant',
        statusColor: '#10B981',
        borderColor: '#10B981',
        ringColor: '#10B981',
        controlsPassing: '41/45',
        rbiCoverage: '86%',
        barColor: '#10B981',
    },
    {
        title: 'Cyber Defence',
        icon: '🛡️',
        percent: 85,
        status: 'Compliant',
        statusColor: '#10B981',
        borderColor: '#3B82F6',
        ringColor: '#3B82F6',
        controlsPassing: '38/45',
        rbiCoverage: '81%',
        barColor: '#3B82F6',
    },
    {
        title: 'Resilience & DR',
        icon: '🔄',
        percent: 78,
        status: 'Partial',
        statusColor: '#F97316',
        borderColor: '#F97316',
        ringColor: '#F97316',
        controlsPassing: '35/45',
        rbiCoverage: '74%',
        barColor: '#F97316',
    },
    {
        title: 'Third-Party Risk',
        icon: '🤝',
        percent: 72,
        status: 'Partial',
        statusColor: '#EF4444',
        borderColor: '#EF4444',
        ringColor: '#EF4444',
        controlsPassing: '32/45',
        rbiCoverage: '68%',
        barColor: '#EF4444',
    },
    {
        title: 'Incident Readiness',
        icon: '🚨',
        percent: 88,
        status: 'Compliant',
        statusColor: '#10B981',
        borderColor: '#8B5CF6',
        ringColor: '#8B5CF6',
        controlsPassing: '40/45',
        rbiCoverage: '84%',
        barColor: '#8B5CF6',
    },
    {
        title: 'Access Control',
        icon: '🔐',
        percent: 80,
        status: 'Compliant',
        statusColor: '#10B981',
        borderColor: '#06B6D4',
        ringColor: '#06B6D4',
        controlsPassing: '36/45',
        rbiCoverage: '76%',
        barColor: '#06B6D4',
    },
];

const banks = ['State Bank of India', 'Punjab National Bank', 'ICICI Bank', 'Bank of India', 'Canara Bank'];

function DomainCompliance() {
    const [selectedBank, setSelectedBank] = useState('State Bank of India');

    return (
        <div className="domain_compliance_page">
            <div className="dc_header">
                <h2 className="dc_title">Domain Compliance — {selectedBank}</h2>
                <select
                    className="dc_bank_select"
                    value={selectedBank}
                    onChange={(e) => setSelectedBank(e.target.value)}
                >
                    {banks.map((bank, i) => (
                        <option key={i} value={bank}>{bank}</option>
                    ))}
                </select>
            </div>

            <div className="dc_grid">
                {complianceData.map((item, idx) => (
                    <div className="dc_card" key={idx} style={{ borderTopColor: item.borderColor }}>
                        <div className="dc_card_top">
                            <div className="dc_card_info">
                                <span className="dc_card_icon">{item.icon}</span>
                                <h4 className="dc_card_title">{item.title}</h4>
                            </div>
                            <div className="dc_ring" style={{ '--ring-color': item.ringColor, '--ring-percent': item.percent }}>
                                <svg viewBox="0 0 36 36" className="dc_ring_svg">
                                    <path
                                        className="dc_ring_bg"
                                        d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"
                                    />
                                    <path
                                        className="dc_ring_fill"
                                        strokeDasharray={`${item.percent}, 100`}
                                        style={{ stroke: item.ringColor }}
                                        d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"
                                    />
                                </svg>
                                <span className="dc_ring_text">{item.percent}%</span>
                            </div>
                        </div>

                        <div className="dc_card_status_row">
                            <span className="dc_status_label">Status</span>
                            <span className="dc_status_value" style={{ color: item.statusColor }}>{item.status}</span>
                        </div>

                        <div className="dc_bar_wrap">
                            <div className="dc_bar_fill" style={{ width: `${item.percent}%`, backgroundColor: item.barColor }}></div>
                        </div>

                        <div className="dc_card_detail">
                            <span>Controls Passing</span>
                            <span>{item.controlsPassing}</span>
                        </div>
                        <div className="dc_card_detail">
                            <span>RBI Clause Coverage</span>
                            <span>{item.rbiCoverage}</span>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}

export default DomainCompliance;
